import "./SurveyPage.css";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import {
    addNewSurveyImage,
    checkDuplicateSurveyTitle,
    deleteSurveyImage,
    getAllSurveyImages,
    getEditSurveyDetails,
    getSasToken,
} from "../../services/survey/survey.service";
import { useLocation, useNavigate } from "react-router-dom";

import Layout1 from "../../assets/layout_1.png";
import Layout2 from "../../assets/layout_2.png";
import Loader from "../common/Loader/Loader";
import ModalComponent from "../common/ModalComponent/ModalComponent";
import { toast } from "react-toastify";
import validateFields from "../../utils/ValidationInput";

const layoutData = [
    {
        name: "Layout One",
        id: 100,
        selected: false,
        imageUrl: Layout1,
        color: "#F5F5F5",
    },
    {
        name: "Layout Two",
        id: 101,
        selected: false,
        imageUrl: Layout2,
        color: "#d4d4d4",
    },
    // {
    //   name: "Layout Three",
    //   id:102,
    //   selected: false,
    //   // imageUrl: Layout1,
    //   color: "#FFF0F5",

    // }
];

const SurveyPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [layouts, setLayouts] = useState(layoutData);
    const [images, setImages] = useState([]);
    const [imageToken, setImageToken] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const { storedSurveyData, from } = location.state || {};
    const [showModal, setShowModal] = useState(false);
    const [imageObj, setImageObj] = useState("");
    const [imageFormData, setImageFormData] = useState({
        imageFile: "",
        imageName: "",
        imageUrl: "",
    });

    const [surveyformData, setSurveyformData] = useState(() => ({
        surveyTitle: storedSurveyData?.surveyTitle || "",
        description: storedSurveyData?.description || "",
        privacyNotice: storedSurveyData?.privacyNotice || "",
        isPrivacyNoticeChecked:
            storedSurveyData?.isPrivacyNoticeChecked || false,
        layoutDetails: storedSurveyData?.layoutDetails || "",
        imageDetails: storedSurveyData?.imageDetails || "",
        languageId: storedSurveyData?.languageId || "",
        isChildPresent: storedSurveyData?.isChildPresent || false,
    }));

    useEffect(() => {
        fetchSasToken();
    }, []);

    useEffect(() => {
        if (storedSurveyData) {
            setSurveyformData({
                surveyId: storedSurveyData?.surveyId || 0,
                surveyTitle: storedSurveyData?.surveyTitle || "",
                description: storedSurveyData?.description || "",
                privacyNotice: storedSurveyData?.privacyNotice || "",
                isPrivacyNoticeChecked:
                    storedSurveyData?.isPrivacyNoticeChecked || false,
                layoutDetails: storedSurveyData?.layoutDetails || "",
                imageDetails: storedSurveyData?.imageDetails || "",
                languageId: storedSurveyData?.languageId || "",
                isChildPresent: storedSurveyData?.isChildPresent || false,
            });
        }

        // Set the selected layout
        if (storedSurveyData?.layoutDetails) {
            setLayouts((prevLayouts) =>
                prevLayouts.map((layout) =>
                    layout.id === storedSurveyData?.layoutDetails.id
                        ? { ...layout, selected: true }
                        : { ...layout, selected: false }
                )
            );
        }
    }, [storedSurveyData]);

    const trimText = (text) => {
        return text.trim().replace(/\s+/g, " ");
    };

    const goToQuestionPage = async () => {
        setLoading(true);
        const requiredFields = [
            {
                label: t("surveyTitle"),
                key: "Survey Title",
                type: "text",
                value: trimText(surveyformData.surveyTitle),
                charLength: 100,
            },
            // {
            //     key: t("surveyTitle"),
            //     type: "text",
            //     value: trimText(surveyformData.description),
            //     charLength: 255,
            // },
            // {
            //     key: t("privacyNotice"),
            //     type: "text",
            //     value: trimText(surveyformData.privacyNotice),
            //     charLength: 8000,
            // },
            {
                label: t("selectLayout"),
                key: "Select Layout",
                type: "",
                value: surveyformData.layoutDetails,
            },
            // {
            //     key: t("selectImage"),
            //     type: "",
            //     value: surveyformData.imageDetails,
            // },
        ];
        const isValid = validateFields(
            surveyformData,
            requiredFields,
            "byValue"
        );
        if (!isValid) {
            setLoading(false);
            return;
        }

        if (surveyformData?.surveyId && surveyformData?.surveyId !== 0) {
            const response = await getEditSurveyDetails(
                surveyformData.surveyId,
                surveyformData.languageId
            );
            const result = combineSurveyAndQuestions(surveyformData, response);
            navigate("/admin/survey/survey-page/question-page", {
                state: {
                    surveyformData: result,
                    from: "admin/survey/survey-page",
                    surveyId: surveyformData.surveyId,
                    survey: surveyformData,
                    storedSurveyDetails: storedSurveyData,
                    isEdit: true,
                    languageId: surveyformData.languageId,
                    isChildPresent: surveyformData.isChildPresent
                },
            });
            setLoading(false);
        } else {
            let isSurveyTitleDuplicate = false;
            const languageDetails = JSON.parse(sessionStorage.getItem("selectedLanguageDetails") || "{}");
            const languageId = languageDetails.id;

            const res = await checkDuplicateSurveyTitle(
                surveyformData.surveyTitle,
                languageId
            );
            if (res && res?.data === true) {
                isSurveyTitleDuplicate = res?.data;
                toast.error(t("surveyTitleExists"), { position: "top-center" });
            }
            if (isSurveyTitleDuplicate) {
                setLoading(false);
                return;
            } else
                navigate("/admin/survey/survey-page/question-page", {
                    state: {
                        surveyformData: surveyformData,
                        from: "admin/survey/survey-page",
                        isEdit: false,
                        languageId: languageId,
                        isChildPresent: false
                    },
                });
            setLoading(false);
        }
    };

    const combineSurveyAndQuestions = (survey, apiResponse) => {
        const sectionMap = {};

        apiResponse.data.forEach((q) => {
            const section = q.sectionTitle || "";
            if (!sectionMap[section]) sectionMap[section] = [];
            sectionMap[section].push({
                id: q.questionId,
                isSectionRequired: q.isSectionRequired,
                sectionTitle: q.sectionTitle || "",
                isMandatory: q.isMandatory,
                questionText: q.questionText,
                surveyQuestionTypeId: q.questionTypeId,
                options: Object.values(JSON.parse(q.options)),
                selectedQueType:
                    { id: q?.questionTypeId, code: q?.code } || null,
                sectionHeading: q.sectionTitle || "",
            });
        });

        return Object.entries(sectionMap).map(([section, questions]) => ({
            section,
            questions,
        }));
    };

    const handleCancel = () => {
        navigate("/admin/survey");
    };

    const fetchSasToken = () => {
        setLoading(true);
        getSasToken().then((response) => {
            if (response !== null) {
                setLoading(false);
                const token = response?.data;
                fetchImages(token);
                setImageToken(token);
            } else {
                setLoading(false);
            }
        });
    };

    const onDeleteImage = (obj) => {
        setImageObj(obj);
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        setLoading(true);
        let payload = {
            imageId: imageObj?.id,
        };
        await deleteSurveyImage(payload).then((response) => {
            if (response?.statusCode === 200 || response?.statusCode === 201) {
                toast.success(t("surveyImageDeleted", { imageName: imageObj?.name }), { position: "top-center" });
                setShowModal(false);
                setImageObj("");
            }
            setLoading(false);
            fetchImages(imageToken);
        });
    };

    const fetchImages = (imageToken) => {
        setLoading(true);
        getAllSurveyImages().then((response) => {
            if (response !== null) {
                setLoading(false);
                const imageData = response?.data?.map((obj) => ({
                    ...obj,
                    uri: obj?.uri + "?" + imageToken,
                    selected:
                        obj.id === storedSurveyData?.imageDetails?.id
                            ? true
                            : false,
                }));
                setImages(imageData);
            } else {
                setLoading(false);
            }
        });
    };

    const handleFileUpload = async () => {
        setLoading(true);
        const requiredFields = [
            {
                label: t("imageUpload"),
                key: "Image Upload",
                type: "image",
                value: imageFormData.imageFile,
            },
        ];
        const isValid = validateFields(
            imageFormData,
            requiredFields,
            "byValue"
        );
        if (!isValid) {
            setLoading(false);
            return;
        }
        const payload = new FormData();
        payload.append("ImageFile", imageFormData.imageFile);
        payload.append("Name", imageFormData.imageName);

        await addNewSurveyImage(payload).then((response) => {
            if (response === null) {
                setIsModalOpen(false);
            } else {
                setIsModalOpen(false);
                fetchImages(imageToken);
            }
            setLoading(false);
        });
    };

    const handleFileChange = (e) => {
        const file = e.files[0];
        let url = URL.createObjectURL(file);

        const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        if (!allowedTypes.includes(file.type)) {
            toast.error(t("onlyJpgPngSvgAllowed"), {
                position: "top-center",
            });
            return;
        }
        // setPreview(url);
        setImageFormData((prevData) => ({
            ...prevData,
            imageUrl: url,
            imageFile: file,
            imageName: file.name,
        }));
    };

    const handleInputChange = (target, field) => {
        if (field === "imageUpload") {
            handleFileChange(target);
        }
    };

    const onChangeInput = (e) => {
        const { name, checked, type, value } = e.target;
        toast.dismiss();
        if (name === "surveyTitle" && value.length > 100) {
            toast.error(t("surveyTitleExceed"), {
                position: "top-center",
            });
            return;
        }
        if (name === "description" && value.length > 255) {
            toast.error(t("descriptionExceed"), {
                position: "top-center",
            });
            return;
        }
        if (name === "privacyNotice" && value.length > 8000) {
            toast.error(t("privacyNoticeExceed"), {
                position: "top-center",
            });
            return;
        }

        setSurveyformData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const onSelectLayout = (layout) => {
        setSurveyformData((prevData) => ({
            ...prevData,
            layoutDetails: layout,
        }));
        setLayouts((prevLayouts) =>
            prevLayouts.map((itm) =>
                itm.id === layout.id
                    ? { ...itm, selected: true }
                    : { ...itm, selected: false }
            )
        );
    };

    const onSelectImg = (obj) => {
        setSurveyformData((prevData) => ({
            ...prevData,
            imageDetails: obj.selected ? '' : obj,
        }));
        setImages((prevImages) =>
            prevImages.map((itm) =>
                itm.id === obj.id
                    ? { ...itm, selected: !itm?.selected }
                    : { ...itm, selected: false }
            )
        );
    };

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div className="survey-container outline col-sm-12">
                    {/* Survey Details */}
                    <div className="survey-details">
                        <h2>{t("surveyCreation")}</h2>
                        <hr />

                        <div className="survey-fields">
                            <label>{t("surveyTitle")}: <span className="required-indicator">*</span></label>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <input
                                    type="text"
                                    placeholder={t('surveyTitle')}
                                    name="surveyTitle"
                                    value={surveyformData["surveyTitle"]}
                                    onChange={(e) => onChangeInput(e)}
                                />
                                <div
                                    style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        marginTop: "1em",
                                        marginLeft: "1em",
                                    }}
                                >
                                    {
                                        (surveyformData["surveyTitle"] || "")
                                            .length
                                    }
                                    /255
                                </div>
                            </div>
                        </div>

                        <div className="survey-fields">
                            <label>{t("surveyShortDescription")}:</label>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <textarea
                                    placeholder={t("description")}
                                    name="description"
                                    value={surveyformData["description"]}
                                    onChange={(e) => onChangeInput(e)}
                                    rows={7}
                                />
                                <div
                                    style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        marginTop: "1em",
                                        marginLeft: "1em",
                                    }}
                                >
                                    {
                                        (surveyformData["description"] || "")
                                            .length
                                    }
                                    /255
                                </div>
                            </div>
                        </div>

                        <div className="survey-fields">
                            <label style={{ height: "16px" }}>
                                {t("privacyNotice")}: <span className="required-indicator">*</span>
                            </label>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                }}
                            >
                                <textarea
                                    rows={10}
                                    // style={{ height: "50%" }}
                                    placeholder={t("privacyNotice")}
                                    name="privacyNotice"
                                    value={surveyformData["privacyNotice"]?.replace(/<[^>]*>/g, '')}
                                    onChange={(e) => onChangeInput(e)}
                                ></textarea>
                                <div
                                    style={{
                                        fontSize: "12px",
                                        color: "#888",
                                        marginTop: "1em",
                                        marginLeft: "1em",
                                    }}
                                >
                                    {
                                        (surveyformData["privacyNotice"] || "")
                                            .length
                                    }
                                    /8000
                                </div>
                            </div>
                        </div>

                        {/* <div style={{ display: "flex", alignItems: "center" }}>
              <input
                id="confirmation"
                type="checkbox"
                style={{
                  margin: "0 0px 0 0",
                  padding: "0",
                  width: "16px",
                  height: "16px",
                }}
                name="isPrivacyNoticeChecked"
                onChange={(e) => onChangeInput(e)}
                value={surveyformData["isPrivacyNoticeChecked"]}
              />
              <label
                htmlFor="confirmation"
                style={{
                  margin: "0",
                  padding: "12px 0px 10px 10px",
                  whiteSpace: "wrap",
                }}
              >
                Privacy Notice with Check box
              </label>
            </div> */}
                    </div>

                    {/* Layout Selection */}
                    <div className="survey-layout-container">
                        {/* Select Layout */}
                        <div className="survey-layout-section">
                            <h2>{t("selectLayout")}</h2>
                            <hr />
                            <div className="survey-layout-buttons">
                                {layouts.map((layout) => (
                                    <div
                                        key={layout.id}
                                        className={`${layout.selected
                                            ? "selectedLayoutBox"
                                            : "layoutBox"
                                            }`}
                                        onClick={() => onSelectLayout(layout)}
                                        style={{
                                            backgroundColor: layout.color,
                                        }}
                                    >
                                        {/* <img src={layout.imageUrl} alt={layout.name} style={{ width: '100%', height: 'auto' }} /> */}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div></div>
                        {/* Image Gallery Section */}
                        <div className="image-gallery-section">
                            <div className="image-gallery-header">
                                <h2 className="h2">{t("selectImages")}</h2>
                                <button
                                    className="survey-new-image-btn"
                                    onClick={() => setIsModalOpen(true)}
                                >
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M10.3333 16.9997H11.6666V11.6663H16.9999V10.333H11.6666V4.99967H10.3333V10.333H4.99992V11.6663H10.3333V16.9997ZM0.333252 21.6663V0.333008H21.6666V21.6663H0.333252ZM1.66659 20.333H20.3333V1.66634H1.66659V20.333Z"
                                            fill="#c80000"
                                        />
                                    </svg>
                                    {t("newImage")}
                                </button>
                            </div>
                            <hr />
                            <div className="image-gallery">
                                {images?.map((obj, index) => (
                                    <div
                                        key={index}
                                        className={`${obj?.selected
                                            ? "selectedImageBox image-wrapper"
                                            : "image-box image-wrapper"
                                            }`}
                                        onClick={() => onSelectImg(obj)}
                                    >
                                        <img
                                            src={obj?.uri}
                                            alt={obj?.name}
                                            style={{
                                                width: "100%",
                                                height: "70px",
                                            }}
                                        />
                                        {/* <span style={{ color: "#B3B2B4", padding: "3px" }}>Image Thumbnail</span> */}
                                        <button
                                            className="delete-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onDeleteImage(obj);
                                            }}
                                        >
                                            &times;
                                        </button>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            <div className="survey-button-group">
                                <button
                                    className="cancelButton"
                                    onClick={handleCancel}
                                >
                                    {t("cancel")}
                                </button>
                                <button
                                    className="saveButton"
                                    onClick={goToQuestionPage}
                                >
                                    {t("next")}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Modal Component */}
                    <ModalComponent
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        onChangeInput={handleInputChange}
                        modalTitle={t("uploadImage")}
                        fieldsData={[
                            {
                                type: "file",
                                name: "imageUpload",
                                showUploadIcon: true,
                            },
                        ]}
                        buttons={[
                            <button
                                key="save"
                                className="saveButton"
                                onClick={() => handleFileUpload()}
                            >
                                {t("upload")}
                            </button>,
                            <button
                                key="cancel"
                                className="cancelButton"
                                onClick={() => setIsModalOpen(false)}
                            >
                                {t("cancel")}
                            </button>,
                        ]}
                    />

                    {/* Reusable Modal Component */}
                    <ModalComponent
                        isOpen={showModal}
                        onClose={() => setShowModal(false)}
                        modalTitle={t("deleteImage")}
                        modalText={`${t("deleteText")} "${imageObj?.name}" ?`}
                        buttons={[
                            <button
                                key="confirm"
                                className="saveButton"
                                onClick={handleConfirmDelete}
                            >
                                {t("confirm")}
                            </button>,
                            <button
                                key="cancel"
                                className="cancelButton"
                                onClick={() => setShowModal(false)}
                            >
                                {t("cancel")}
                            </button>,
                        ]}
                    />
                </div>
            )}
        </>
    );
};

export default SurveyPage;
